import useWorkflowInstance from "backend/hooks/workflows/useWorkflowInstance";
import useWorkflowLogs from "backend/hooks/workflows/useWorkflowLogs";
import useWorkflowSteps from "backend/hooks/workflows/useWorkflowSteps";
import Todo from "design/components/misc/Todo";
import MeasureTable from "design/components/tables/MeasureTable";
import ExecutiveDashboardTitle from "design/components/texts/ExecutiveDashboardTitle";
import React from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";

export type IStepConfig = {
  title: string | JSX.Element;
  aliases: string[];
};
const WorkflowSteps = (props: {
  workflowId?: string;
  showSteps: IStepConfig[];
  isVertical?: boolean;
}) => {
  const { data: steps, isLoading: isLogsLoading } = useWorkflowSteps(
    props.workflowId
  );
  const { data: task, isLoading: isTaskLoading } = useWorkflowInstance(
    props.workflowId
  );

  if (!steps) return null;
  return (
    <div style={{ width: "100%" }}>
      {steps ? (
        <Stepper
          activeStep={(task?.level || 4) - 1}
          orientation={props.isVertical ? "vertical" : "horizontal"}
        >
          {props.showSteps.map((step) => {
            const [findStep] = steps.filter((s) =>
              step.aliases.includes(s.state)
            );
            return (
              <Step>
                <StepLabel>
                  {step.title}
                  <div>{isTaskLoading ? "" : findStep?.username}</div>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      ) : null}
    </div>
  );
};

export default WorkflowSteps;
